<div class="session-expired-page-container">
  <app-session-expired class="z-index--1"></app-session-expired>
  <app-circles-background class="circle-background"></app-circles-background>
</div>
